import { useRouter } from '../../../../hooks/router'
import '../Quizes.scss'

const EndQuiz = ({ callbackSetShowQuiz, levelUser }) => {

    const router = useRouter()

    const changeUrl = () => {

        callbackSetShowQuiz(true)

        router.push('/')

    }

    return (
        <div className="endQuiz-main">

            <div className='quiz-correct-answers'>

                <div className='collect'>
                    <p>You are</p>
                    <p className='glasses-count'>{levelUser}</p>
                    <p>level </p>
                </div>

                <div className='submit-answers'>
                    <button onClick={changeUrl}>Enter</button>
                </div>

            </div>

        </div>
    )

}


export default EndQuiz